import { useState } from 'react';
import type { ReactElement } from 'react';

import { ApiRoute } from 'config';
import { get } from 'utils/network';

import useAsyncEffect from 'hooks/useAsyncEffect';

import FriendBuyAuth from 'models/FriendBuyAuth';

function Refer(): ReactElement {
  const [isLoading, setIsLoading] = useState(true);

  useAsyncEffect(async (isMounted) => {
    const { parsedBody, ok } = await get<FriendBuyAuth>(ApiRoute.FB_SIGNATURE);

    if (isMounted.current && ok) {
      // @ts-expect-error TODO: fix null safety
      await window.friendbuyAPI.push(['auth', parsedBody.auth_string, parsedBody.signature]);
      setIsLoading(false);
    }
  }, []);

  return (
    <div className="col-12 col-lg-10">
      <div className="c-refer-and-earn" data-fragment="refer-and-earn">
        <h1 className="c-heading c-heading--center c-heading--brand-4 mb-0">
          Refer & Earn
        </h1>

        {!isLoading && <div className="friendbuyadvocatewidget" />}
      </div>
    </div>
  );
}

export default Refer;
